export default __webpack_public_path__ + "static/media/hht2_ep13_speaking_03.83f49dd0.png";